import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { auth, db } from '../firebase';
import { captureError } from './errorReporting';

// Automatic crash reporting: writes uncaught errors to the `clientErrors`
// Firestore collection so failures are visible without users filing reports.
// Throttled and deduplicated per session; must never throw.

const MAX_REPORTS_PER_SESSION = 10;
let reportCount = 0;
const seenMessages = new Set<string>();

export const reportClientError = (error: unknown, context?: Record<string, unknown>): void => {
  try {
    const captured = captureError(error, context);

    if (reportCount >= MAX_REPORTS_PER_SESSION) return;
    const dedupeKey = captured.message.slice(0, 200);
    if (seenMessages.has(dedupeKey)) return;

    const user = auth.currentUser;
    if (!user) return; // rules require an authenticated author

    seenMessages.add(dedupeKey);
    reportCount++;

    addDoc(collection(db, 'clientErrors'), {
      message: captured.message.slice(0, 500),
      code: (captured.code || '').slice(0, 100),
      stack: (captured.stack || '').slice(0, 4000),
      pageUrl: captured.pageUrl.slice(0, 500),
      appVersion: captured.appVersion,
      userAgent: captured.userAgent.slice(0, 300),
      context: context ? JSON.stringify(context).slice(0, 2000) : '',
      userId: user.uid,
      createdAt: serverTimestamp(),
    }).catch(() => {
      // Reporting is best-effort; swallow so telemetry can never break the app
    });
  } catch {
    // Never let telemetry itself crash anything
  }
};
